import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { configureAuth, AuthProvider } from "@atlas/auth";
import { config } from "./config";
import { App } from "./App";
import "./index.css";

// Configure Amplify Auth with Cognito settings
configureAuth(config.cognito);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
